let  buildInfo = {};
export default buildInfo;